import { resourcesCopy } from '@/copy/resources'
import { TextField } from '@/ui/Field/Field'
import { type FieldProps, type Fields, fieldStr } from './shared'

// eslint-disable-next-line react-refresh/only-export-components -- local component; the descriptor below is this file's only export
function GitRepoFields({ fields, set, isEdit }: FieldProps) {
  return (
    <>
      <TextField
        id="res-remote"
        label={resourcesCopy.forms.gitRepo.remote}
        value={fields.remote_url ?? ''}
        onValue={(v) => set('remote_url', v)}
        inputProps={{
          placeholder: resourcesCopy.forms.gitRepo.remotePlaceholder,
        }}
      />
      <TextField
        id="res-branch"
        label={resourcesCopy.forms.gitRepo.branch}
        value={fields.branch ?? 'main'}
        onValue={(v) => set('branch', v)}
        inputProps={{
          placeholder: resourcesCopy.forms.gitRepo.branchPlaceholder,
        }}
      />
      <TextField
        id="res-token"
        label={resourcesCopy.forms.gitRepo.token}
        hint={
          isEdit
            ? resourcesCopy.form.leaveBlankToKeep
            : resourcesCopy.form.optional
        }
        value={fields.token ?? ''}
        onValue={(v) => set('token', v)}
        inputProps={{
          type: 'password',
          placeholder: resourcesCopy.forms.gitRepo.tokenPlaceholder,
        }}
      />
    </>
  )
}

// `clone_path` has no input but round-trips through the stored data, so it is
// preserved on edit without being user-editable here.
export const gitRepoForm = {
  Fields: GitRepoFields,
  toBody: (f: Fields) => ({
    remote_url: f.remote_url ?? '',
    branch: f.branch || 'main',
    clone_path: f.clone_path ?? '',
    ...(f.token ? { token: f.token } : {}),
  }),
  fromResource: (d: unknown) => ({
    remote_url: fieldStr(d, 'remote_url'),
    branch: fieldStr(d, 'branch', 'main'),
    clone_path: fieldStr(d, 'clone_path'),
  }),
}
